import '@lottiefiles/lottie-player'

function ModalStyledLoader({ small = false }) {
  if (small) {
    return (
      <lottie-player
        loop
        autoplay
        style={{
          width: '50px',
          height: '50px',
          marginTop: '-13px',
          marginLeft: '12px',
          marginRight: '12px',
        }}
        src="https://assets6.lottiefiles.com/packages/lf20_u98PhF.json"
        speed="1"
      ></lottie-player>
    )
  } else {
    return (
      <lottie-player
        autoplay
        loop
        style={{ width: '100px', height: '100px', margin: 'auto' }}
        src="https://assets6.lottiefiles.com/packages/lf20_u98PhF.json"
        speed="1"
      ></lottie-player>
    )
  }
}

export default ModalStyledLoader
